<h2 mat-dialog-title>Select Serial(s)</h2>
<mat-dialog-content>
  <mat-selection-list #selList [multiple]="true" cdkFocusInitial>
    <mat-list-option *ngFor="let m of data.matches" [value]="m">
      {{ m.product_serial_number || '—' }}
    </mat-list-option>
  </mat-selection-list>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button
    mat-button
    color="primary"
    [disabled]="(selList?.selectedOptions?.selected?.length || 0) === 0"
    (click)="onAdd()">
    Add
  </button>
</mat-dialog-actions>